import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  flex: {
    display: 'flex',
    flexWrap: 'wrap',
    [theme.breakpoints.down(theme.size.sm)]: {
      flexDirection: 'column',
    },
  },
  parent: {
    maxWidth: '50%',
    flexBasis: '50%',
    padding: 15,
    [theme.breakpoints.down(theme.size.sm)]: {
      maxWidth: '100%',
      flexBasis: '100%',
      width: '100%',
    },
    [theme.breakpoints.down(theme.size.xs)]: {
      padding: '10px 5px',
    },
  },
  topBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  wrapper: {
    flex: 1,
  },
  wrapperRight: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginBottom: 17,
  },
  dateIcon: {
    marginRight: 10,
    fontSize: '1.4rem',
    color: theme.custom.darkBlue,
  },
  text: {
    fontSize: 14,
    color: theme.custom.darkBlue,
  },
}));
